import { fetchBaseQuery } from "@reduxjs/toolkit/query";

import { authApi } from "./services/auth";
import { setAccessToken } from "./slices/user.slice";

// Define base query with authorization header
export const baseQuery = fetchBaseQuery({
  baseUrl: process.env.BACKEND_URL,

  prepareHeaders: (headers) => {
    const token = localStorage.getItem("access_token");
    if (token) {
      headers.set("authorization", `Bearer ${token}`);
    }
    return headers;
  },
});

export const baseQueryWithReauth = async (args, store, extraOptions) => {
  let result = await baseQuery(args, store, extraOptions);

  if (result.error && result.error.status === 401) {
    try {
      console.warn("baseQueryWithReauth: request returned 401", {
        args,
        error: result.error,
      });
    } catch (e) {
      console.error("baseQueryWithReauth: failed to log 401 info", e);
    }
    const refresh_token = localStorage.getItem("refresh_token");
    if (refresh_token) {
      const refreshResult = await baseQuery(
        `/auth/refresh?refresh_token=${refresh_token}`,
        store,
        extraOptions,
      );

      if (refreshResult.data) {
        // Store the new tokens
        localStorage.setItem("access_token", refreshResult.data.access_token);
        localStorage.setItem("refresh_token", refreshResult.data.refresh_token);

        store.dispatch(setAccessToken(refreshResult.data.access_token));
        // Retry the original request
        result = await baseQuery(args, store, extraOptions);
      } else {
        console.warn("baseQueryWithReauth: refresh failed, dispatching logout");
        store.dispatch(authApi.endpoints.logout.initiate());
      }
    } else {
      console.warn(
        "baseQueryWithReauth: no refresh_token found, dispatching logout",
      );
      store.dispatch(authApi.endpoints.logout.initiate());
    }
  }
  return result;
};
